import Checkbox from '@material-ui/core/Checkbox';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled, { css } from 'styled-components';

/**
 * Estilização do componente StyledTreeView
 */
export const StyledTreeView = styled(TreeView)`
  height: 216px;
  flex-grow: 1;
  max-width: 100%;
  padding: 0px 10px 0px 16px !important;
  

  li.MuiTreeItem-root {
    height: 49px;
    border-bottom: 0.3px solid #c3c3c3;    
  }

  ${({ highlightFirstLayer }) =>
    highlightFirstLayer &&
    css`
      li:first-child {
        .MuiTreeItem-label {
          background-color: #d9e7ff !important;
        }    
      }
    `}

  .Mui-expanded {
    border-top: 1px solid #ccc;
    height: auto;
    display: contents;
  }

  .MuiTreeItem-group {
    margin-left: 0px;
    border-bottom: 1px solid #ccc;
  }
`;

/**
 * Estilização do componente BaseTreeItem
 */
const BaseTreeItem = styled(TreeItem)`
  box-sizing: border-box;

  li.MuiTreeItem-root {
    border-bottom: 0px solid #ccc;
  }

  &.Mui-expanded {
    .MuiTreeItem-content {
      color: #3c71dd;
    }
  }

  &.Mui-selected > .MuiTreeItem-content > .MuiTreeItem-label {
    background-color: #fff !important;
  }

  .MuiTreeItem-content {
    position: relative;
    left: -5px;
    height: 100%;
  }

  .MuiTreeItem-content > .MuiTreeItem-label:hover {
    background-color: #d9e7ff !important;
  }  

  .MuiTreeItem-label {
    padding-left: 0px;
    height: 100%;
    font-size: 14px !important;
    line-height: 16px !important;
  }

  .MuiTreeItem-iconContainer {
    width: 0px;
  }

  .custom_tree_item {
    position: relative;
    height: 100%;
    padding: 8px 0;

    @media (min-width: 768px) {
      width: 100%;
    }
  }
`;

/**
 * Estilização do componente StyledTreeItem
 */
export const StyledTreeItem = styled(BaseTreeItem)`
  .MuiTreeItem-content {
    margin-bottom: unset;
  }

  .custom_tree_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 0;
  }

  p {
    font-family: Roboto;
    font-style: normal;
    font-size: 14px;
    font-weight: 400;    
    line-height: 16px;
    color: #5e5e5e;
    margin: 0;
    width: 90%;
    padding-top: 18px;
    padding-left: 6px;    
  }

  span {
    padding-top: 14px;
  }
  
  &.active {
    p {
      color: #3c71dd;
    }
  }
`;

/**
 * Estilização do componente StyledCheckbox
 */
export const StyledCheckbox = styled(Checkbox)`
  &.MuiCheckbox-colorPrimary {
    color: #c3c3c3;
  }

  &.MuiCheckbox-colorPrimary.Mui-checked {
    color: #3c71dd;
  }

  .MuiSvgIcon-fontSizeSmall {
    font-size: 1rem;
  }
`;
